// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "./utils/rem";
import router from "./router";
import axios from "axios";
import "@/assets/css/reset.css";
import "@/assets/css/public.css";

import VueAMap from "vue-amap";
import { createApp } from "vue";
import waterfall from 'vue-waterfall2'

Vue.use(waterfall)
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "56abebf15fd463d57daec214f71f7985",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geolocation"
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4"
});

// import VideoPlayer from "vue-video-player";
// require("video.js/dist/video-js.css");
// require("vue-video-player/src/custom-theme.css");
// const hls = require('videojs-contrib-hls')
// Vue.use(hls)

Vue.use(VideoPlayer);
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);

import uploadIcon from "@/assets/img/jia.png";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import * as echarts from "echarts";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(uploadIcon);
Vue.use(Vant);

import filter from "./utils/filter";
Vue.use(filter);
// 瀑布流插件
// import waterfall from "vue-waterfall2";
// Vue.use(waterfall);

import "./utils/jquery-3.6.0.min";

import "./utils/NativeShare";
// import mui from "./utils/mui";

Vue.prototype.axios = axios;
// Vue.prototype.$mui = mui;
Vue.config.productionTip = false;
// Vue.prototype.$ImgUrl = "http://192.168.1.91:8089";
// 正式
// Vue.prototype.$ImgUrl = "http://www.airlib.com:8123";
Vue.prototype.$ImgUrl = "https://xytvadmin.hlrmt.com";  //正式地址
// Vue.prototype.$ImgUrl = "http://192.168.1.99:8111";  //测试地址


Vue.prototype.$errorImg = "@/assets/img/loadError.png";
Vue.prototype.getImg = (url) => {
	if (url) {
		const regex = /http/i
		if(regex.test(url)){
			return url;
		}else{
			return 'https://xytvadmin.hlrmt.com' + url; //正式d
			// return 'http://192.168.1.99:8111' + url; //测试
		}
	}else {
	  return '';
	}
}

document.addEventListener('UniAppJSBridgeReady', function() {
Vue.prototype.$uni = uni
// console.log( uni,"11111");
  // uni.webView.navigateTo(...)
});
// Vue.prototype.$ImgUrl = "http://192.168.1.91:8089/";
// Vue.prototype.$axios = axios;
import AMap from "vue-amap";
import preventReClick from "./utils/preventReClick"; //防多次点击，重复提交
Vue.use(AMap);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js